<template>
  <div class="piggery iot">
    <div class="banner" :style="`background-image:url(${banner.picUrl})`" @click="goBannerUrl" :class="{canClick: banner.connection}">
      <h1 class="font-60">用农信的钱，购买农信商城的“优选产品” </h1>
      <h1 class="font-60">养好您的猪！</h1>
    </div>
    <div class="middle-content">
      <div class="mol-1 pt-0">
        <div class="title-gap">
          <h2>{{modelList.typeName}}</h2>
        </div>
        <p class="txt-inline">{{modelList.typeDescribe}}</p>
        <img class="img-1" :src="modelList.pictureUrl" />
      </div>

      <div v-for="(item, index) in modelList.modeViewDTOList" :key="index">
      <div class="mol-1 flex-box-justify-space-between replace-div" v-if="index % 2 === 0 && item.state === '0'">
        <div class="mol-1-item">
          <img class="img-7" :src="item.pictureUrl" />
        </div>
        <div class="mol-1-item">
          <div class="item-center">
            <div class="s-title-gap">
              <h2>{{item.modelName}}</h2>
            </div>
            <p>{{item.content}}</p>
          </div>
        </div>
      </div>

      <div class="mol-1 flex-box-justify-space-between" v-else-if="index % 2 !== 0 && item.state === '0'">
        <div class="mol-1-item">
          <div class="item-center">
            <div class="s-title-gap">
              <h2>{{item.modelName}}</h2>
            </div>
            <p>{{item.content}}</p>
          </div>
        </div>
        <div class="mol-1-item">
          <img class="img-7" :src="item.pictureUrl" />
        </div>
      </div>
      </div>

      <section class="module mol-4 finance">
        <div class="content bg-2">
          <div class="des">
            <h2>金融模式流程</h2>
          </div>
          <ul class="flow-list clearfix">
            <li class="cont" data-scroll-reveal>
              <div class="icon-w-2">
                <i class="icon icon-7" />
              </div>
              <p class="icon-p">担保授信</p>
            </li>
            <li class="arrow" data-scroll-reveal="wait 0.1s">
              <i class="icon-arrow" />
            </li>
            <li class="cont" data-scroll-reveal="wait 0.2s">
              <div class="icon-w-2">
                <i class="icon icon-8" />
              </div>
              <p>商城采购\付首款</p>
            </li>
            <li class="arrow" data-scroll-reveal="wait 0.3s">
              <i class="icon-arrow" />
            </li>
            <li class="cont" data-scroll-reveal="wait 0.4s">
              <div class="icon-w-2">
                <i class="icon icon-9" />
              </div>
              <p>发货\确认收货</p>
            </li>
            <li class="arrow" data-scroll-reveal="wait 0.5s">
              <i class="icon-arrow" />
            </li>
            <li class="cont" data-scroll-reveal="wait 0.6s">
              <div class="icon-w-2">
                <i class="icon icon-10" />
              </div>
              <p>选农信租付尾款</p>
            </li>
            <li class="arrow" data-scroll-reveal="wait 0.7s">
              <i class="icon-arrow" />
            </li>
            <li class="cont" data-scroll-reveal="wait 0.8s">
              <div class="icon-w-2">
                <i class="icon icon-11" />
              </div>
              <p>买方按期还款</p>
            </li>
            <li class="arrow" data-scroll-reveal="wait 0.7s">
              <i class="icon-arrow" />
            </li>
            <li class="cont" data-scroll-reveal="wait 0.8s">
              <div class="icon-w-2">
                <i class="icon icon-12" />
              </div>
              <p>完成</p>
            </li>
          </ul>
        </div>
      </section>

    </div>
  </div>
</template>

<script>
import { getSession, setSession } from '@/utils/index'
export default {
  name: 'finance',
  data () {
    return {
      banner: {
        picUrl: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg'
      },
      modelList: []
    }
  },
  mounted () {
    if (!getSession('bannerPic')) {
      this.getBannerPage()
    } else {
      this.banner = getSession('bannerPic').financial_model
    }
    this.getAllModel()
    this.$scroll.reveal('.banner h1', {
      distance: '50px',
      origin: 'left',
      duration: 1000
    })
  },
  methods: {
    /**
     * 获取 banner 图片
     */
    async getBannerPage () {
      const params = {
        currentPage: 1,
        pageSize: 100
      }
      const res = await this.API.basic.getBannerPage(params) || []
      // eslint-disable-next-line prefer-const
      let arr = {}
      res.data.map(o => {
        this.$set(arr, o.remark, { picUrl: o.pictureUrl, connection: o.connection })
      })
      this.banner = arr.financial_model
      setSession('bannerPic', arr)
    },
    /** 跳转banner配置连接 */
    goBannerUrl () {
      if (!this.banner.connection) {
        return ''
      }
      window.open(this.banner.connection)
    },
    /** 子模式获取 */
    async getAllModel () {
      const res = await this.API.recruit.listAllmodel()
      const list = res.data || []
      list.map(o => {
        if (o.typeName === '金融模式') {
          this.modelList = o
        }
      })
    }
  }
}
</script>
